import { render, staticRenderFns } from "./Buildings.vue?vue&type=template&id=9955e1ca&"
import script from "./Buildings.vue?vue&type=script&lang=ts&"
export * from "./Buildings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports